/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon16Light = forwardRef('ArrowDUturnRightUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M15.874 6.168a.5.5 0 1 1-.748.664L12 3.315V8.5a5.5 5.5 0 0 1-11 0v-4a.5.5 0 0 1 1 0v4a4.5 4.5 0 1 0 9 0V3.315L7.874 6.832a.5.5 0 1 1-.748-.664l3.253-3.66a1.5 1.5 0 0 1 2.242 0l3.253 3.66Z" })));
});
